// extracted by mini-css-extract-plugin
export default {"container":"RV-z","title":"SV-z","link":"TV-z"};